import dayjs from "../../../shared/utils/date";

const ADVISORY_TYPE_LABELS = {
    release: "Release",
    lifecycle: "Lifecycle",
    security: "Security",
    operational: "Operational",
};

/**
 * Subscription-facing display order, which differs from the filter-bar order in
 * `useAdvisoryFilters` (ADVISORY_TYPES). Kept here so the subscription modal can
 * reuse the labels above without importing the filter hook.
 */
export const ADVISORY_TYPE_OPTIONS = ["security", "lifecycle", "operational", "release"].map(
    (value) => ({ value, label: ADVISORY_TYPE_LABELS[value] }),
);

/**
 * The API returns lowercase `advisory_type` values and occasionally `null`
 * (advisories created before the field was mandatory).
 */
export const getAdvisoryTypeLabel = (advisoryType) => {
    const key = advisoryType?.toLowerCase?.()?.trim();
    if (!key) return "\u2014";
    return ADVISORY_TYPE_LABELS[key] || advisoryType;
};

/**
 * Advisories GA date (UTC). The "NEW" badge that flags advisories as a newly shipped
 * feature is meant to be temporary -- 30 days after GA it stops being news and becomes
 * clutter, so it retires itself rather than waiting on someone to remember to delete it.
 *
 * Anchored to a fixed GA date (not per-user first-visit) so every user sees the badge
 * disappear on the same day, which keeps screenshots and docs consistent. The comparison
 * is done in UTC deliberately: this app presents all timestamps in UTC (see the Help
 * modal's time-zone FAQ), and a local-midnight anchor would otherwise retire the badge on
 * different calendar days either side of the date line.
 */
export const ADVISORIES_GA_DATE = "2026-09-28";
export const ADVISORIES_NEW_BADGE_DAYS = 30;

/** True until 2026-10-28T00:00Z, after which the advisories "NEW" badge stops rendering. */
export const isAdvisoriesNewBadgeVisible = (now = Date.now()) => (
    dayjs(now).utc().isBefore(
        dayjs.utc(ADVISORIES_GA_DATE).add(ADVISORIES_NEW_BADGE_DAYS, "day"),
    )
);

export default getAdvisoryTypeLabel;
